import React, { useState } from 'react'

import Button from './Button'
import Card from './Card'

import './MiniPosts.css'
import './PostSection.css'

export const PostSection = ({
  posts = [],
  title = '',
  postLimit,
  showLoadMore = true,
  loadMoreTitle = 'View more posts',
  perPageLimit = 10,
  mainPost = true
}) => {
  const [limit, setLimit] = useState(postLimit || 10)

  const increaseLimit = () => setLimit(prevState => prevState + perPageLimit)

  const visiblePosts = posts.slice(0, limit || posts.length)

  return (
    <div className="PostSection">
      {title && <h2 className="PostSection--Title">{title}</h2>}
      {posts.length === 0 && (
        <h3 className="PostSection--EmptyPost">Nothing here yet.</h3>
      )}
      {mainPost && !!visiblePosts.length && (
        <div className="PostSection--MainPost">
          {visiblePosts.slice(0, 1).map((post, index) => (
            <Card
              key={post.title + index}
              {...post}
              type="Max"
              slugText="Read full story"
              content={post.excerpt}
            />
          ))}
        </div>
      )}
      {!!visiblePosts.length &&
        (mainPost ? (
          <div className="PostSection--Grid">
            {visiblePosts.slice(1, visiblePosts.length).map((post, index) => (
              <Card
                key={post.title + index}
                {...post}
                type="Mini"
                slugText="Read article"
              />
            ))}
          </div>
        ) : (
          <div className="PostSection--Grid">
            {visiblePosts.map((post, index) => (
              <Card
                key={post.title + index}
                {...post}
                type="Mini"
                slugText="Read article"
              />
            ))}
          </div>
        ))}
      {showLoadMore && visiblePosts.length < posts.length && (
        <div className="taCenter">
          <Button text={loadMoreTitle} onClick={() => increaseLimit()} />
        </div>
      )}
    </div>
  )
}

export default PostSection
